import { render, staticRenderFns } from "./houseProvident.vue?vue&type=template&id=701963fa&scoped=true&"
import script from "./houseProvident.vue?vue&type=script&lang=js&"
export * from "./houseProvident.vue?vue&type=script&lang=js&"
import style0 from "./houseProvident.vue?vue&type=style&index=0&id=701963fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701963fa",
  null
  
)

export default component.exports